import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { SidebarProvider } from 'react/contexts/SidebarContext';
import SidebarContainer from './Sidebar';

function Sidebar({ menus }) {
  return (
    <SidebarProvider menus={menus}>
      <SidebarContainer />
    </SidebarProvider>
  );
}

Sidebar.defaultProps = {
  menus: []
};

Sidebar.propTypes = {
  menus: PropTypes.array.isRequired
};

export default memo(Sidebar);
